import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { BookmarkService } from "src/app/secure/bookmarks/bookmarks.service";
import { BookmarkGroup } from "src/interfaces/session/session-bookmark";
import { TemplateTextComponent } from "../../../prefixes/templates/template-text/template-text.component";
import { DialogTitle } from "../../template/dialog-template.component";
import { DialogComponent } from "../dialog.component";

export interface BookmarkGroupEditData {
  title: DialogTitle;
  bookmarkGroup: BookmarkGroup;
}

@Component({
  selector: "app-bookmark-group-edit",
  imports: [TemplateTextComponent, MatButtonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: "./bookmark-group-edit.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./bookmark-group-edit.component.less",
})
export class BookmarkGroupEditComponent extends DialogComponent<BookmarkGroupEditData> implements OnInit {
  public control: FormControl<string | null>;
  private bookmarks: BookmarkService;

  public constructor() {
    super();
    this.control = new FormControl<string | null>(null, Validators.required);
    this.bookmarks = inject(BookmarkService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.data) {
      this.control.patchValue(this.data.bookmarkGroup.Description || null);
    }
  }

  public async onSubmit(): Promise<void> {
    if (this.data && this.control.value) {
      this.bookmarks.editBookmarkGroup(this.data.bookmarkGroup, this.control.value);
      await this.bookmarks.saveBookmarks();
      this.close();
    }
  }
}
